import { useState } from 'react';
import ChatBox from './ChatBox';
// import './ChatBox.css';

function ChatBoxComponent(props) {
    if(props.isModePreview){
        import('./ChatBox.css')
    }
    const isModePreview = props?.isModePreview ? true : false;
    const [isEnableChatBox, setIsEnableChatBox] = useState(false);
    const isChatBoxEnable =
        (isEnableChatBox &&
            props?.publicKnowledgeSetting?.isShowChatbot &&
            props?.publicKnowledgeSetting?.isActiveUrl) ||
        (isEnableChatBox && props.isIframeChatBot) ||
        isModePreview;

    const classNameChatBox = isChatBoxEnable
        ? `chatBox-enable ${isModePreview ? 'chatBox-enable-preview' : ''}`
        : 'chatBox-disable';
    if (props.isIframeChatBot) {
        document.getElementsByTagName('body')[0].style.setProperty("background", "transparent", "important");
    }
    
    return (
        <div className={isModePreview ? 'preview-box' : ""}>
            <div className={classNameChatBox}>
                <ChatBox
                    {...props}
                    setIsEnableChatBox={setIsEnableChatBox}
                    isModePreview={isModePreview}
                    accessChatBoxDomain={
                        props.accessDomain ? props.accessDomain : process.env.REACT_APP_DOMAIN_NAME
                    }
                />
            </div>
        </div>
    );
}

export default ChatBoxComponent;
